import { createReducer } from '../../../store/reducerUtils';

export const key = 'operatorList';

export const CONFIG_BTN = `${key}/CONFIG_BTN`;
export const CHANGE_BTN = `${key}/CHANGE_BTN`;
export const INIT_BTN = `${key}/INIT_BTN`;
export const INIT_SUCCESS_BTN = `${key}/INIT_SUCCESS_BTN`;
export const DEL_BTN = `${key}/DEL_BTN`;

export const PAGEINFO = `${key}/PAGEINFO`;
export const RANGEINIT = `${key}/RANGEINIT`;


/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */

export const showConfigBtn = (isShow) => ({
  type: CONFIG_BTN,
  isShow: isShow,
});

export const showChangeBtn = (isShow) => ({
  type: CHANGE_BTN,
  isShow: isShow,
});

export const showInitBtn = (isShow) => ({
  type: INIT_BTN,
  isShow: isShow,
});

export const showInitSuccessBtn = (isShow) => ({
  type: INIT_SUCCESS_BTN,
  isShow: isShow,
});

export const showDelBtn = (isShow) => ({
  type: DEL_BTN,
  isShow: isShow,
});


const ACTION_HANDLERS = {
  [CONFIG_BTN]: (state, action) => {
    return {
      ...state,
      configBtn: action.isShow,
      changeBtn: false,
      initBtn: false,
      delBtn: false,
      initSuccessBtn: false,
    };
  },
  [CHANGE_BTN]: (state, action) => {
    return {
      ...state,
      configBtn: false,
      changeBtn: action.isShow,
      initBtn: false,
      delBtn: false,
      initSuccessBtn: false,
    };
  },
  [INIT_BTN]: (state, action) => {
    return {
      ...state,
      configBtn: false,
      changeBtn: false,
      initBtn: action.isShow,
      delBtn: false,
      initSuccessBtn: false,
    };
  },
  [DEL_BTN]: (state, action) => {
    return {
      ...state,
      configBtn: false,
      changeBtn: false,
      initBtn: false,
      delBtn: action.isShow,
      initSuccessBtn: false,
    };
  },
  [INIT_SUCCESS_BTN]: (state, action) => {
    return {
      ...state,
      configBtn: false,
      changeBtn: false,
      initBtn: false,
      delBtn: false,
      initSuccessBtn: action.isShow,
    };
  },
  [PAGEINFO]: (state, action) => {
    return {
      ...state,
      operatorInfoPageList: action.operatorInfoPageList,
    };
  },
  [RANGEINIT]: (state, action) => {
    return {
      ...state,
      roleAndProduct: action.roleAndProduct,
    };
  },
};

const initialState = {
  configBtn: false,
  changeBtn: false,
  initBtn: false,
  initSuccessBtn: false,
  delBtn: false,
  operatorInfoPageList: {},
  roleAndProduct: {},
};

export default createReducer(initialState, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/views/Business/OperatorList/operatorListReducer.js